import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import Comission from 'services/Comission'
import General from 'services/General'
import DateInput from 'components/Inputs/DateInput'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import { 
  InfoContainer,
  FilterContainer,
  LabelRow,
  SubTitle,
  MoneyTextMask
} from '../styles'

export default function Expenses () {
  const now = DateTime.now ().setLocale ('pt-BR')
  const [loading, setLoading] = useState (true)
  const [schedulesByMonth, setSchedulesByMonth] = useState ([])
  const [schedulesByDay, setSchedulesByDay] = useState ([])
  const [monthExpenses, setMonthExpenses] = useState (0)
  const [businessExpenses, setBusinessExpenses] = useState (0)
  const [professionalExpenses, setProfessionalExpenses] = useState (0)
  const [dateRange, setDateRange] = useState ([
    now.startOf ('month').toISODate (),
    now.toISODate ()
  ])
  const token = AuthService.getToken ()
  const cutileiFilter = { value: 'cutilei' }

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getSchedulesByMonth ()
  }, [dateRange])

  const getSchedulesByMonth = async () => {
    try {
      setLoading (true)
      
      const startDate = dateRange ? dateRange[0] : null
      const endDate = dateRange ? dateRange[1] : null
      const filters = `?order=desc&start_date=${startDate}&end_date=${endDate}`
                    + `&cutilei_schedules=true&status=validated&deleted=false&page=1&per_page=999999`

      const { data: scheduleResponse } = await cutileiApi.get (`/schedules${filters}`, requestConfig)

      const schedules = scheduleResponse.data.map (schedule => ({...schedule, type: 'cutilei'}))
      setSchedulesByMonth (schedules)
      setSchedulesByDay (General.groupBy (schedules, 'date'))
      setMonthExpenses (Comission.getTotalEarnings (schedules, cutileiFilter))
      setBusinessExpenses (Comission.getBusinessEarnings (schedules, cutileiFilter))
      setProfessionalExpenses (Comission.getProfessionalEarnings (schedules, cutileiFilter))
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <>
      <FilterContainer style={{
        width: 240,
        gridTemplateColumns: '1fr',
        justifyItems: 'center'
      }}>
        <DateInput
          value={dateRange}
          selectRange={true}
          onChange={setDateRange}
          style={{width: 240}}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginBlock: 20}}/> : (
        <>
          <LabelRow>
            <SubTitle>Dia</SubTitle>
            <SubTitle>Total a pagar</SubTitle>
            <SubTitle>Comissão dos salões</SubTitle>
            <SubTitle>Comissão dos profissionais</SubTitle>
          </LabelRow>
          <InfoContainer 
            to={{ pathname: '/admin/expenses/monthly' }}
            state={{
              dateRange,
              monthExpenses,
              businessExpenses,
              professionalExpenses,
              schedulesByMonth
            }}
          >
            <SubTitle>TOTAL DO PERÍODO</SubTitle>
            <MoneyTextMask value={monthExpenses}/>
            <MoneyTextMask value={businessExpenses}/>
            <MoneyTextMask value={professionalExpenses}/>
            <FA.FaChevronRight size={15} color='#252525'/>
          </InfoContainer>
          {schedulesByDay.map ((daySchedules, index) => {
            const formattedDay = DateTime.fromISO (daySchedules[0].date).toFormat ('dd/MM/yyyy')

            return (
              <InfoContainer
                key={index}
                to='/admin/expenses/daily'
                state={{ formattedDay, daySchedules }}
              >
                <SubTitle>{formattedDay}</SubTitle>
                <MoneyTextMask value={Comission.getTotalEarnings (daySchedules, cutileiFilter)}/>
                <MoneyTextMask value={Comission.getBusinessEarnings (daySchedules, cutileiFilter)}/>
                <MoneyTextMask value={Comission.getProfessionalEarnings (daySchedules, cutileiFilter)}/>
                <FA.FaChevronRight size={15} color='#252525'/>
              </InfoContainer>
            )
          })}
        </>
      )}
    </>
  )
}
